import * as React from "react";
import Alert from "@mui/material/Alert";
import GlobalTheme from "../../../styles/global.theme";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CloseIcon from "@mui/icons-material/Close";

export default function CustomAlert({ message, severity = "error", onClose }) {
  const customStyles = {
    success: {
      backgroundColor: GlobalTheme.palette.purple.primary.secondary,
      color: GlobalTheme.palette.purple.primary.main,
    },
    error: {
      backgroundColor: GlobalTheme.palette.pink.primary.darker,
      color: GlobalTheme.palette.pink.primary.main,
    },
  };
  const icon = severity === "error" && (
    <ErrorOutlineIcon sx={{ color: GlobalTheme.palette.pink.primary.main }} />
  );

  return (
      <Alert
        severity={severity}
        sx={{
          ...(severity === "success"
            ? customStyles.success
            : customStyles.error),
          width: "100%",  
          fontSize: "18px",
          fontWeight: "400",
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
        }}
        icon={icon}
        action={
          severity === "success" ? (
            <CloseIcon
              sx={{
                marginTop: "-4px",
                marginRight: "10px",
                cursor: "pointer",
                color: GlobalTheme.palette.purple.primary.main,
              }}
              onClick={onClose}
            />
          ) : null
        }
      >
        {message}
      </Alert>
  );
}
